import React from 'react'
import cn from 'classnames'

import ModalBody from 'app/components/Modal/ModalBody'
import Button from 'app/components/ButtonDefault'
import { IOnboardingFirstActivityModalProps } from 'app/domains/routes/OnBoarding/OnBoardingFirstActivityModal/interface'
import { COMMIT } from 'app/constants/identityActions'

import './styles.scss'

const bc = 'on-boarding-first-activity-modal'

const OnboardingFirstActivityModal = ({
  t,
  image,
  proQuote,
  proQuoteAuthor,
  description,
  onDid,
  i18n: { language },
  activityId,
  userActivityId,
  closeModalOrShowQuiz,
  currentActionCommitType,
}: IOnboardingFirstActivityModalProps) => {
  return (
    <ModalBody withoutCross className={`${bc}__wrapper`}>
      <div className={`${bc}__title`}>{t('You committed to this action')}</div>
      <div className={`${bc}__body`}>
        <img className={`${bc}__image`} src={image} alt={t('Action image')} />
        <p className={`${bc}__proQuote`}>{`"${proQuote}"`}</p>
        <div className={`${bc}__proQuoteAuthor`}>— {proQuoteAuthor}</div>
        <h3 className={`${bc}__goal`}>{t('What are your goals?')}</h3>
        <p className={`${bc}__description`} dangerouslySetInnerHTML={{ __html: description }} />
      </div>
      <div className={`${bc}__footer`}>
        <div className={`${bc}__wrapper-complete`}>
          <Button
            className={`${bc}__button`}
            primary
            onClick={() => {
              onDid({ activityId, userActivityId })
              closeModalOrShowQuiz()
            }}
            disabled={currentActionCommitType !== COMMIT}
          >
            {t('I Did it')}
          </Button>
          <span className={`${bc}__text`}>{t('Complete your activity now')}</span>
        </div>
        <div className={cn(`${bc}__or`, { [`${bc}__or__${language}`]: language })} />
        <div className={`${bc}__wrapper-continue`}>
          <Button
            className={`${bc}__button-continue`}
            onClick={() => {
              closeModalOrShowQuiz()
            }}
          >
            {t('Continue')}
          </Button>
          <span className={`${bc}__text`}>{t('Continue to preferences and receive a reminder later today')}</span>
        </div>
      </div>
    </ModalBody>
  )
}

export default OnboardingFirstActivityModal
